import { DiseaseForGridModel } from '../disease/diseaseForGridModel';
import { MedicineForListModel } from '../medicine/medicineForListModel';

export class UserAdminModel {
  public userId: number;
  public name: string;
  public email: string;
  public password: string;
  public activationCode: string;
  public facebookUserId: string;
  public birthDate: string;
  public createdOn: string;
  public updatedOn: string;
  public lastLogged: string;
  public isDeleted: boolean;
  public isActive: boolean;
  public diseases: Array<DiseaseForGridModel>
  public medicines: Array<MedicineForListModel>
}